import { render } from "./ListiniDataTable.vue?vue&type=template&id=c4ecac7e"
import script from "./ListiniDataTable.vue?vue&type=script&lang=js"
export * from "./ListiniDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__